module.exports = __webpack_public_path__ + "static/img/RedJack.5ea0dff.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gifs/RedJack.gif
// module id = jlo2
// module chunks = 1